import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dialogs-host]',
})
export class DialogsDirective {
  public viewContainerRef = inject(ViewContainerRef);
}
